export const timelineMarkerWidth = 11;
